module.exports = __webpack_public_path__ + "img/login.81187d77.jpg";